import httpClient from './httpClient'
import axios from 'axios'
import { API_URL } from '../config/envs'
export default {
  async getMemberReferrals() {
    let ret = await httpClient.get('member-referrals')
    return ret
  },
  async getMemberReferralById(referral_id) {
    const endpoint = `${API_URL}stripe/checkout?referral_id=${referral_id}`
    let ret = await axios.get(endpoint)
    return ret
  },
  async getMemberTransactions() {
    let ret = await httpClient.get('member-referrals/transactions')
    return ret
  },
  async sendInviteEmail(body) {
    let ret = await httpClient.post('member-referrals/invite', body)
    return ret
  },
}
